import { setupPrefetchData } from '~vueutil/vue.js'
import { reactive } from 'vue'
import { defineStore } from 'pinia'
import { useRpcapi } from '~vueutil/pinia.js'

const name = 'network-info'
export const useStore = defineStore(name, () => {
  const rpcapi = useRpcapi()

  const networkInfo = reactive({
    currentTimeInMs: 0,
    websiteUrl: '',
    tagManagerId: '',
    location: null
  })

  async function fetchData () {
    const result = await rpcapi.getNetworkInfo()
    if (!result) {
      return
    }

    return Object.assign(networkInfo, result)
  }

  return setupPrefetchData({
    fetchData,

    networkInfo,
    getNetworkInfo () {
      return networkInfo
    }
  })
})

export function getNetworkInfo () {
  const store = useStore()
  return store.getNetworkInfo()
}
